import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { getSelectedSecuritySurveillancePermission } from '@capital-access/common/security';
import { TARGETING_COMMON_KEY } from '../../constants';

@Component({
  selector: 'ca-targeting-surveillance-data-info',
  templateUrl: './surveillance-data-info.component.html',
  standalone: false
})
export class SurveillanceDataInfoComponent {
  localizationKey: string = TARGETING_COMMON_KEY;

  isSurveillanceSecurity$ = this.store.select(getSelectedSecuritySurveillancePermission);

  constructor(private store: Store) {}
}
